"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatForumsAudienceCopy = exports.isTypeSlugInList = exports.matchesForumsAudience = exports.canCreateTopicOnForum = exports.canPostOnForums = exports.canSeeForum = exports.canAccessForums = exports.canSeeForumsNav = exports.hasActivePaidMembership = void 0;
__exportStar(require("./CommonMongoModelFields"), exports);
__exportStar(require("./ObjectId"), exports);
__exportStar(require("./utils"), exports);
__exportStar(require("./dateUtils"), exports);
__exportStar(require("./membershipUtils"), exports);
__exportStar(require("./memberFeatureFlags"), exports);
var forumAccess_1 = require("./forumAccess");
Object.defineProperty(exports, "hasActivePaidMembership", { enumerable: true, get: function () { return forumAccess_1.hasActivePaidMembership; } });
Object.defineProperty(exports, "canSeeForumsNav", { enumerable: true, get: function () { return forumAccess_1.canSeeForumsNav; } });
Object.defineProperty(exports, "canAccessForums", { enumerable: true, get: function () { return forumAccess_1.canAccessForums; } });
Object.defineProperty(exports, "canSeeForum", { enumerable: true, get: function () { return forumAccess_1.canSeeForum; } });
Object.defineProperty(exports, "canPostOnForums", { enumerable: true, get: function () { return forumAccess_1.canPostOnForums; } });
Object.defineProperty(exports, "canCreateTopicOnForum", { enumerable: true, get: function () { return forumAccess_1.canCreateTopicOnForum; } });
Object.defineProperty(exports, "matchesForumsAudience", { enumerable: true, get: function () { return forumAccess_1.matchesForumsAudience; } });
Object.defineProperty(exports, "isTypeSlugInList", { enumerable: true, get: function () { return forumAccess_1.isTypeSlugInList; } });
Object.defineProperty(exports, "formatForumsAudienceCopy", { enumerable: true, get: function () { return forumAccess_1.formatForumsAudienceCopy; } });
__exportStar(require("./forumGuidelines"), exports);
__exportStar(require("./forumModeration"), exports);
__exportStar(require("./forumComments"), exports);
__exportStar(require("./forumPartner"), exports);
__exportStar(require("./forumTeaser"), exports);
__exportStar(require("./forumsLimits"), exports);
__exportStar(require("./forumParticipants"), exports);
__exportStar(require("./forumUnread"), exports);
__exportStar(require("./sstFeatureFlags"), exports);
__exportStar(require("./authFeatureFlags"), exports);
//# sourceMappingURL=index.js.map